import $ from "jquery";
// export var gf_location = "";
let gf_bodyPart = "";
let gfExtraFields = ['selectBodypart', 'txtLocation'];

// let gfArr = [
// 	{value:'Ankle', text:'Ankle'},
// 	{value:'Arm', text:'Arm'},
// 	{value:'Clavicle', text:'Clavicle'},
// 	{value:'Elbow', text:'Elbow'},
// 	{value:'Femur', text:'Femur'},
// 	{value:'Foot', text:'Foot'},
// 	{value:'Forearm', text:'Forearm'},
// 	{value:'Hand', text:'Hand'},
// 	{value:'Hip', text:'Hip'},
// 	{value:'Humerus', text:'Humerus'},
// 	{value:'Knee', text:'Knee'},
// 	{value:'Leg', text:'Leg'},
// 	{value:'Pelvis', text:'Pelvis'},
// 	{value:'Radius and Ulna', text:'Radius and Ulna'},
// 	{value:'Shoulder', text:'Shoulder'},
// 	{value:'Thigh', text:'Thigh'},
// 	{value:'Tibia and Fibula', text:'Tibia and Fibula'},
// 	{value:'Wrist', text:'Wrist'}
// 	];

export function getExtraFieldJson(gf_location,gf_bodyPart) {
	var response = {};
	var v = null;
	var el = null;
	var arr = null;
	let value = "";
	for(var i=0; i<gfExtraFields.length; i++) {
		el = $('#' + gfExtraFields[i]);
		if(el == null || el == undefined) {
			continue;
		}
		v = el.val();
		if(v == null || v == undefined) {
			if(i == 0 && gf_bodyPart !== ''){
				v = gf_bodyPart;
			}
			else if(i == 1 && gf_location !== ''){
				v = gf_location;
			}
			else{
				continue;	
			}
		}
		if(i === 0){
			gf_bodyPart = v;
			value = gf_bodyPart;	
		}
		if(i === 1)
		{
			gf_location = v;
			value = gf_location;
		}	
		arr = new Array();
		arr.push(value);
		response[gfExtraFields[i]] = arr;
	}
	return response;
 }